
import React from 'react'
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout"
import VehicleMaintenanceForm from "./VehicleMaintenanceComponents/VehicleMaintenanceForm";

import { useAddVehicleMaintenanceMutation } from "store/services/vehicleMaintenanceApi";

import { useAppMeta } from "hooks";

const VehicleMaintenanceCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vehicle Maintenance", path: "/app/crm/vehicle-maintenance/list" },
    { title: "New Vehicle Maintenance" },
  ];

  // RTK Query
  const [createVehicleMaintenance, { isLoading: creatingVehicleMaintenance }]
  = useAddVehicleMaintenanceMutation();

  // method
  const handelCreateVehicleMaintenance = async (data) =>{
    try{
      const {_id} = await createVehicleMaintenance(data).unwrap();
      toast.success("Vehicle Maintenance is Created !");
      navigate(`/app/crm/vehicle-maintenance/${_id}/detail`)
    }catch(error){
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Vehicle Maintenance !"
      );
    }
  };

  useAppMeta("New Vehicle Maintenance");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingVehicleMaintenance}>
      <BreadcrumbLayout.Paper>
        <VehicleMaintenanceForm isBusy={creatingVehicleMaintenance} onSubmit={handelCreateVehicleMaintenance} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default VehicleMaintenanceCreateScreen